import { render } from "./UserControl.vue?vue&type=template&id=3811f9f2&scoped=true"
import script from "./UserControl.vue?vue&type=script&lang=js"
export * from "./UserControl.vue?vue&type=script&lang=js"

import "./UserControl.vue?vue&type=style&index=0&id=3811f9f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3811f9f2"]])

export default __exports__